import { createCardRoutes } from "lib/core/routing/card-routing"
import LibraryResourceContainer from "library/show/components/LibraryResourceContainer"
import path from "path-browserify"
import { inviteCardRoute } from "../invitation/invite/routes"

export default createCardRoutes(
  "/library/:resourceSlug/:cohortId(\\d+)/:section/",
  {
    invite: {
      ...inviteCardRoute.invite,
      getDefaultLaunchedFrom: ({ location }) =>
        path.join(location.pathname, "../")
    }
  },
  LibraryResourceContainer
)
